// Color palette matching the provided SVG design
export const colors = {
  white: '#ffffff',      // Pure white for main backgrounds
  lightGray: '#f8f9fa',  // App background (keeping current)
  lightBackground: '#f3f5f0', // Light contrast background from SVG
  primaryBrown: '#977d3f', // Main brown/gold from SVG (also Gold)
  lightCream: '#f4f4d9',   // Light cream from SVG
  darkText: '#232428',     // Dark gray text from SVG
  charcoal: '#212529',     // Fallback dark text
  gray: '#6c757d',         // Medium gray for secondary text
  border: '#dee2e6',       // Light border color
  
  // Additional colors from README
  creamLight: '#f6f7e4',   // Cream Light (Background)
  cream: '#f4f5d7',        // Cream (Cards)
  gold: '#d6ac22',         // Gold (Primary)
  tan: '#a18a52',          // Tan (Secondary)
  navyBlue: '#233a54',     // Navy Blue (Headers)
  olive: '#7a8455',        // Olive (Accents)
};

export default colors;
